package com.evoapps.evoshift.data.dto.owner

import kotlinx.serialization.Serializable

/**
 * SH-267: workplace_groups/{id}, written by functions/workplaceGroups.js only. Later tickets add
 * fields the app does not read yet (settings); the server keeps them on every save.
 * SH-268: [managers] (uid to their level), written by functions/groupManagers.js only.
 */
@Serializable
data class WorkplaceGroupDto(
    val id: String = "",
    val ownerId: String = "",
    val name: String = "",
    val workplaceIds: List<String> = emptyList(),
    val isDefault: Boolean = false,
    val managers: Map<String, GroupManagerDto> = emptyMap()
)

/** SH-268: workplace_groups/{id}.managers[uid]. */
@Serializable
data class GroupManagerDto(
    val permission: String = "MANAGER",
    val addedAt: String? = null,
    val addedBy: String? = null
)
